import React from "react"
import ReactJoyride, { Props } from "react-joyride"
type WalkthroughType = Props & {}
const Walkthrough = ({ ...props }: WalkthroughType) => {
  return (
    <ReactJoyride
      locale={{
        open: "Continue the walkthrough",
      }}
      styles={{
        options: {
          // This displays below the selector popovers
          zIndex: 19,
          primaryColor: "#799700",
          textColor: "#41464B",
        },
      }}
      disableOverlayClose
      showProgress={true}
      continuous
      showSkipButton
      spotlightClicks={true}
      {...props}
    />
  )
}

export default Walkthrough
